const i2iInTitle = require('../i2iInTitle');

module.exports = linkInfo => {
  const a = document.createElement('a');
  a.href = linkInfo.url;
  a.target = linkInfo.target || '_self';
  a.classList.add('ads__link');
  a.innerHTML = i2iInTitle(linkInfo.title);
  return a;
}
